/* eslint-disable jsx-a11y/alt-text */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles/components/Header.module.css";
import useApi from "../hooks/useApi";
import { useAuth } from "../providers/AuthProvider";

import listIcon from "../images/list-icon.svg";
import profileIcon from "../images/profile-circle.svg";
import bellIcon from "../images/bell.svg";

import { useDispatch, useSelector } from "react-redux";
import { getCoins, spendCoin, addCoin } from "../reducers/coinSlice";

const Header = ({ children }) => {
  const { get, post } = useApi();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const coins = useSelector((state) => state.coin.amount);
  const status = useSelector((state) => state.coin.status);
  const error = useSelector((state) => state.coin.error);

  const [profile, setProfile] = useState({});
  const [profileOpen, setIsProfileOpen] = useState(false);

  useEffect(() => {
    if (status === "idle") {
      dispatch(getCoins(get));
    }
  }, [status, dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get("/webapp/profile/");
        setProfile(response);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  const toggleMenu = () => {
    setIsProfileOpen(!profileOpen);
  };

  const handleBack = () => {
    navigate(-1);
  };
  
  const handleLogOut = async () => {
    const response = await post("/accounts/logout/");
    setIsProfileOpen(false);
    logout();
  };

  return (
    <div className={styles.header}>
      <div className={styles.leftMenu}>
        <div>
          <img className={styles.listIcon} src={listIcon} />
        </div>

        <div className={styles.backButton} onClick={()=>navigate('/')}>
          PlayGen
        </div>
        <div className={styles.backButton} onClick={handleBack}>
          &larr; {"Back"}
        </div>
      </div>

      <div className={styles.rightMenu}>
        <div className={styles.coinContent}>
          {/* <div className={styles.coinText}>{profile.credits}</div> */}
          <div className={styles.coinText}>{coins}</div>
          <div className={styles.divider} />
          <button
            className={styles.membershipButton}
            onClick={() => navigate("/pricing")}
          >
            Purchase a membership plan to get credits
          </button>
        </div>

        <button className={styles.bellButton}>
          <img className={styles.bellIcon} src={bellIcon} />
        </button>

        <div className={styles.username}>
          <p>{profile.username}</p>
        </div>

        <button className={styles.profileButton} onClick={toggleMenu}>
          <img className={styles.profileIcon} src={profileIcon} />
        </button>
        <div>{children}</div>
      </div>

      {profileOpen && (
        <div
          style={{
            position: "absolute",
            top: "60px",
            right: "0",
            backgroundColor: "#fff",
            border: "1px solid #ddd",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            padding: "10px",
            zIndex: 1000,
          }}
        >
          <button
            onClick={handleLogOut}
            style={{
              backgroundColor: "#ff4d4d",
              color: "#fff",
              border: "none",
              padding: "8px 12px",
              borderRadius: "4px",
              cursor: "pointer",
              width: "100%",
            }}
          >
            Log Out
          </button>
        </div>
      )}
    </div>
  );
};

export default Header;
